import React from 'react';
import PropTypes from 'prop-types';
import NotificationsWrapper from '../../notifications/NotificationsWrapper';

export default class VerifyForm extends React.Component {
    render() {
        let suggestedAddress = null;
        if ( this.props.verifiedAddress && this.props.verifiedAddress.country === 'USA' ) {
            suggestedAddress = (
                <div className="rec-form-check-wrap">
                    <label htmlFor="suggested" className="rec-label-radio">
                        <input className="rec-input-hide" id="suggested" type="radio" name="suggested" value="suggested" onChange={this.props.handleOptionChange} />
                        <span className="rec-input-radio" />
                        <strong>Use Suggested Address</strong>
                        <address>
                            <div>{this.props.verifiedAddress.address1}</div>
                            <div>{this.props.verifiedAddress.address2}</div>
                            <div>{this.props.verifiedAddress.city}, {this.props.verifiedAddress.state} {this.props.verifiedAddress.zip_code}</div>
                            <div>{this.props.verifiedAddress.country}</div>
                        </address>
                    </label>
                </div>
            );
        }
        let unableToValidateMessage = null;
        if (this.props.unableToVerify) {
            unableToValidateMessage = (
                <div className="rec-verify-contact-unable-to-verify-message">
                    <p>No suggested address.</p>
                </div>
            );
        }
        let originalAddressInvalidMessage = null;
        if (!this.props.originalAddressValid) {
            originalAddressInvalidMessage = (
                <div className="rec-verify-contact-original-address-invalid-message">
                    <NotificationsWrapper noticeType="error">
                        <p>The original address inputed is missing required fields.</p>
                    </NotificationsWrapper>
                </div>
            );
        }
        return (
            <div>
                {originalAddressInvalidMessage}
                <div className="rec-verify-contact-row">
                    {unableToValidateMessage}
                    {suggestedAddress}
                    <div className="rec-form-check-wrap">
                        <label htmlFor="original" className="rec-label-radio">
                            <input className="rec-input-hide" id="original" type="radio" name="suggested" value="original" onChange={this.props.handleOptionChange} />
                            <span className="rec-input-radio" />
                            <strong>Use Original Address</strong>
                            <address>
                                <div>{this.props.currentAddress.address1}</div>
                                <div>{this.props.currentAddress.address2}</div>
                                <div>{this.props.currentAddress.city}, {this.props.currentAddress.state} {this.props.currentAddress.zip_code}</div>
                                <div>{this.props.currentAddress.country}</div>
                            </address>
                        </label>
                    </div>
                </div>
                <div className="rec-verify-contact-footer">
                    <button
                        disabled={this.props.disableSaveBtn}
                        className="rec-button-primary"
                        onClick={this.props.saveProfile}>
                        Save
                    </button>
                    <button
                        className="rec-button-tertiary"
                        onClick={this.props.editProfile}>
                        Edit Address
                    </button>
                </div>
            </div>
        )
    }
}

VerifyForm.propTypes = {
    handleOptionChange: PropTypes.func.isRequired,
    saveProfile: PropTypes.func.isRequired,
    editProfile: PropTypes.func.isRequired,
    verifiedAddress: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip_code: PropTypes.string,
        country: PropTypes.string
    }),
    currentAddress: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip_code: PropTypes.string,
        country: PropTypes.string
    }).isRequired,
    unableToVerify: PropTypes.bool,
    originalAddressValid: PropTypes.bool,
    disableSaveBtn: PropTypes.bool
};
